import { Dispatch } from "redux";
import { UserActionsTypes, SET_USERDATA } from "types/actions/UserData.actions";

export const setUserData = (userData: any) => {
  return (dispatch: Dispatch<UserActionsTypes>) => {
    dispatch({ type: SET_USERDATA, userData: userData });
  };
};
